module.exports = __webpack_public_path__ + "assets/reporte.5dbf29532e3badcdc0e913765249c62a.svg";


//////////////////
// WEBPACK FOOTER
// ./img/reporte.svg
// module id = 941
// module chunks = 0